import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AuthService } from '../../services/auth.service';
import { ConfigurationService } from '../../configuration/configuration.service';
import { MessageService } from '../../common/message.service/message.service';

import * as $ from 'jquery';
import { Router } from '@angular/router';
import { IScheduleJob } from '../../common/schedule.service/schedule.job.model';
import { ScheduleService } from '../../common';
import { NotificationManagementService } from '../../modules/notification/notification.service';
import { View } from '../../common/model/view';
import { SignalRService } from '../../services/signalr.service';
import { DataEntryAttachmentService } from '../../modules';

@Component({
  selector: 'header-bar',
  templateUrl: './header.component.pug',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent implements OnInit, OnDestroy, IScheduleJob {

  get user() {
    return this.authService.user;
  }

  public realeaseDate: string;
  public releaseNotesUrl: string;
  public darkTheme = false;
  public authUrl: string;

  private isExpanded = false;
  private userDataSubscription: Subscription;
  private isAuthorizedSubscription: Subscription;

  private notificationIds = new Array<string>();
  private notificationCount = 0;

  id = 'HeaderNotificationPuller';
  udpateInterval = 30;
  callback = () => { this.fetchNotifications(undefined); };

  constructor(
    public authService: AuthService,
    private config: ConfigurationService,
    private messageService: MessageService,
    private router: Router,
    private configurationService: ConfigurationService,
    private intervalService: ScheduleService,
    private notificationManagementService: NotificationManagementService,
    private dataEntryAttachmentService: DataEntryAttachmentService,
    public signalRService: SignalRService
  ) {
    this.realeaseDate = 'build ' + (this.configurationService.gitDate || this.configurationService.releaseDate);
    this.releaseNotesUrl = this.configurationService.releaseNotesUrl + `?instance=${encodeURIComponent(this.configurationService.watermark)}&hash=${this.configurationService.gitHash}`;
    this.authService.notificationChanged.subscribe((event) => { this.fetchNotifications(event); });
  }

  ngOnInit(): void {
    this.authService.enableSilentRenew();
    this.signalRService.addUpdateUnreadNotificationsCountListener().subscribe(nc => this.notificationCount = nc);

    if (this.authService.isAuthorized) { this.fetchNotifications(undefined); }

    const router = this.router;
    this.userDataSubscription = this.authService.getUser().subscribe(
      (userData: any) => {
        setTimeout(() => {
          if (userData.mandatory_update) { router.navigate(['/profile/edit']); }
          if (userData.mandatory_authenticator) { window.location.href = '/auth/Manage/TwoFactorAuthentication'; }
        }, 0);
      });

    if (localStorage.getItem('ThemeCode') === 'dark') { this.darkTheme = true; }
  }

  ngOnDestroy(): void {
    this.userDataSubscription.unsubscribe();
    if (this.isAuthorizedSubscription) { this.isAuthorizedSubscription.unsubscribe(); }
    $('#loginModal').modal('hide');
    $('#unAuthModal').modal('hide');
  }

  public login() {
    this.isAuthorizedSubscription = this.authService.getIsAuthorized().subscribe((isAuthorized: boolean) => {
      if (isAuthorized) { $('#loginModal').modal('hide'); $('#unAuthModal').modal('hide'); }
    });

    this.authService.oidcSecurityService.authorize((authUrl) => {
      /*this.authUrl = 'about.blank';
      this.authUrl = authUrl;*/
      window.location.href = authUrl;
    });
  }

  public newcase() {
    this.router.navigate(['/case/anon']);
  }

  public refreshSession() {
    this.authService.refreshSession();
  }

  public logout() {
    this.authService.logout();
  }

  public toggleTheme() {
    this.darkTheme = !this.darkTheme;
    this.messageService.setTheme(this.darkTheme ? 'dark' : 'light');
  }

  public refreshFrame() {
    const frame = $('#loginFrame');
    frame[0].src = frame[0].src;
  }

  public hasFileUpload() {
    return this.authService.uploadProgress.length;
  }

  public hasFileUploadInProgress() {
    return this.authService.uploadProgress.some(p => p.inprogress);
  }

  public getProgressClasses(progress) {
    if (progress.error) return 'progress_error';
    if (progress.percentage == 100) return 'progress_done';
    return 'progress_inprogress';
  }

  public removeProgress(progress) {
    var idx = this.authService.uploadProgress.indexOf(progress);
    this.authService.uploadProgress.splice(idx,1);
  }

  private fetchNotifications(notificationId: string) {
    if (this.signalRService.IsConnected) return;

    if (notificationId) {
      this.notificationIds.push(notificationId);

      const view = new View();
      view.addOrUpdateFilter('deleted', false);
      view.addOrUpdateFilter('profileId', this.user.profile_id);
      view.addOrUpdateFilter('hasManifest', true);

      this.notificationManagementService.getNotifications(view).then((Notifications) => {
        this.notificationCount = Notifications.value.length;
      });

      this.intervalService.add(this);
    } else {
      if (this.notificationIds.length === 0) {
        this.intervalService.remove(this.id);

        const view = new View();
        view.addOrUpdateFilter('deleted', false);
        view.addOrUpdateFilter('profileId', this.user.profile_id);
        view.addOrUpdateFilter('hasManifest', true);

        this.notificationManagementService.getNotifications(view).then((Notifications) => {
          this.notificationCount = Notifications.value.length;
        });
      }

      this.notificationIds.forEach(async id => {
        const notification = await this.notificationManagementService.getById(id);

        if (!notification.deleted && notification.hasManifest) {
          const index = this.notificationIds.indexOf(notification.id);
          this.notificationIds.splice(index, 1);

          this.notificationCount = this.notificationCount + 1;
        } else if (notification.deleted) {
          const index = this.notificationIds.indexOf(notification.id);
          this.notificationIds.splice(index, 1);

          if (this.notificationCount > 0) {this.notificationCount = this.notificationCount - 1; }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/header/header.component.ts